export const lastSixDigits = (requisitionId) => {
  if (!requisitionId) {
    return;
  }

  const length = requisitionId.length;
  const lastSix = length <= 6 ? requisitionId : `...${requisitionId.substr(length - 6)}`;

  return lastSix;
}
